import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BehaviorSubject, ReplaySubject, Subscription } from 'rxjs';

const MAX_PAGE_SIZE = 100;

@Component({
  selector: 'app-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
})
export class TablePaginationComponent implements OnInit, OnDestroy {
  @Input() public totalNumberOfElements = 0;
  @Input()
  public numberOfElementsChangedBehavioralSubject$: BehaviorSubject<number>;
  @Input() public resetPagesReplaySubject$?: ReplaySubject<number>;
  @Output() public paginationNumberOnClick = new EventEmitter<number>();

  // paging
  public pageNumber = 1;
  public totalPages = 1;
  public startIndex = 1;
  public endIndex: number;

  private readonly _pageSize = MAX_PAGE_SIZE;

  // Subscription
  private _numberOfElementsChangedSubscription$: Subscription;
  private _resetPagesSubscription$?: Subscription;

  constructor() {
    this.endIndex = this._pageSize;
  }

  ngOnInit(): void {
    this._numberOfElementsChangedSubscription$ = this.numberOfElementsChangedBehavioralSubject$.subscribe(
      (numberOfElements) => {
        this.totalNumberOfElements = numberOfElements;
        this._updateTotalPages();
        this._updatePagination();
      }
    );

    this._resetPagesSubscription$ = this.resetPagesReplaySubject$?.subscribe((numberOfElements: number) => {
      this.pageNumber = 1;
      this.totalNumberOfElements = numberOfElements;
      this._updateTotalPages();
      this._updatePagination();
    });
  }

  ngOnDestroy(): void {
    this._numberOfElementsChangedSubscription$.unsubscribe();
    this._resetPagesSubscription$?.unsubscribe();
  }

  public prevPageClicked() {
    this.pageNumber -= 1;
    this._updatePagination();
    this.paginationNumberOnClick.emit(this.pageNumber);
  }

  public nextPageClicked() {
    this.pageNumber += 1;
    this._updatePagination();
    this.paginationNumberOnClick.emit(this.pageNumber);
  }

  private _updatePagination() {
    this.startIndex = (this.pageNumber - 1) * this._pageSize + 1;
    if (this.pageNumber == this.totalPages) {
      this.endIndex = (this.pageNumber - 1) * this._pageSize + (this.totalNumberOfElements % this._pageSize);
    } else {
      this.endIndex = this.pageNumber * this._pageSize;
    }
  }

  private _updateTotalPages() {
    const extraPageNeeded: number = this.totalNumberOfElements % MAX_PAGE_SIZE > 0 ? 1 : 0;
    this.totalPages = Math.floor(this.totalNumberOfElements / MAX_PAGE_SIZE) + extraPageNeeded;

    if (this.totalPages == 0) {
      this.totalPages = 1;
    }

    if (this.pageNumber > this.totalPages) {
      this.pageNumber = this.totalPages;
    }
  }
}
